// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1Nf3w","subTitle":"styles_subTitle__2N7pr"};